import {
  CalculateResult,
  CalculatorItem,
  Price,
  ProductBonus,
  ProductCondition,
  ProductGroupReferences,
  SelectedPrice,
  Ticket,
} from '@product/const';
import { ProductReference, StateUtils } from '@spartacus/core';

export const PRODUCT_FEATURE = 'CustomProduct';
export const TICKET_PROCESS_ID = 'Ticket';

export const CALCULATORS = '[CustomCatalog] Calculator';
export const PRODUCT_CONDITIONS = '[CustomCatalog] Product Conditions';
export const CALCULATOR_RESULT = '[CustomCatalog] Calculator result';
export const SELECTED_PRICE = '[CustomCatalog] Selected Price';
export const PRICES = '[CustomCatalog] Prices';
export const BONUSES = '[CustomCatalog] Bonuses';
export const GROUP_REFERENCES = '[CustomCatalog] Group References';
export const PRODUCT_GROUP_REFERENCES = '[CustomCatalog] Product Group References';

export interface ProductState {
  selectedPrice: StateUtils.EntityLoaderState<SelectedPrice>;
  prices: StateUtils.EntityLoaderState<Price[]>;
  bonuses: StateUtils.EntityLoaderState<ProductBonus[]>;
  ticket: StateUtils.LoaderState<Ticket>;
  calculatorList: StateUtils.EntityLoaderState<CalculatorItem[]>;
  calculatorResult: StateUtils.LoaderState<CalculateResult>;
  groupReferences: StateUtils.EntityLoaderState<ProductGroupReferences[]>;
  productGroupReferences: StateUtils.EntityLoaderState<ProductReference[]>;
  productConditions: StateUtils.EntityLoaderState<ProductCondition[]>;
}

export interface StateWithProduct {
  [PRODUCT_FEATURE]: ProductState;
}
